export default __webpack_public_path__ + "static/media/house.88807ad7.png";